import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { set } from "lodash";
import { defaultFormData, initialState } from "./initialState";
import { IData, IExcelDetailsData, IExcelListData } from "../types";
import { DataActiveStatusEnum } from "../../Category/types";

export const useClinicSlice = createSlice({
  name: "productRetailerState",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setButtonLoading: (state, action: PayloadAction<boolean>) => {
      state.buttonLoading = action.payload;
    },
    setToggleLoading: (state, action: PayloadAction<boolean>) => {
      state.toggleLoading = action.payload;
    },
    setSearch: (state, action: PayloadAction<string>) => {
      state.search = action.payload;
    },
    setPageNo: (state, action: PayloadAction<number>) => {
      state.pageNo = action.payload;
    },
    setPageSize: (state, action: PayloadAction<number>) => {
      state.pageSize = action.payload;
    },
    setTotalRow: (state, action: PayloadAction<number>) => {
      state.totalRow = action.payload;
    },

    setOrderDir: (state, action: PayloadAction<string>) => {
      state.orderDir = action.payload;
    },
    setOrderBy: (state, action: PayloadAction<string>) => {
      state.orderBy = action.payload;
    },

    updateFormValue: (
      state,
      action: PayloadAction<{ key: string; value: any }>
    ) => {
      set(state, `formData.${action.payload.key}`, action.payload.value);
    },
    doRemoveImages: (
      state,
      action: PayloadAction<{
        name: string;
        index: number;
      }>
    ) => {
      const { name, index } = action.payload;
      const items = state.formData[name as keyof IData];

      if (!items || !Array.isArray(items)) return;

      const imageItem = items[index];

      if (imageItem && imageItem._id) {
        imageItem.isRemove = true;
      } else {
        items.splice(index, 1);
      }
    },

    updateImagesFormValue: (
      state,
      action: PayloadAction<{ name: string; value: any }>
    ) => {
      const { name, value } = action.payload;
      (state.formData[name as keyof IData] as any[]).push({ file: value });
    },
    updateFeaturedImageFormValue: (state, action: PayloadAction<string>) => {
      const newImage = action.payload;

      if (state.formData.featuredImage.length > 0) {
        state.formData.featuredImage.forEach((img) => {
          img.isRemove = true;
        });
      }
      state.formData.featuredImage.push({
        file: newImage,
        _id: "",
        isRemove: false,
      });
    },
    clearFrom: (state) => {
      state.formData = { ...defaultFormData };
    },

    doCreate: (state, action: PayloadAction<{ callback: () => void }>) => {},
    doUpdate: (state, action: PayloadAction<{ callback: () => void }>) => {},
    doUpdateStatus: (
      state,
      action: PayloadAction<{
        id: string;
        index: number;
        callback: () => void;
      }>
    ) => {
      state.list[action.payload.index].status =
        state.list[action.payload.index].status === DataActiveStatusEnum.ACTIVE
          ? DataActiveStatusEnum.INACTIVE
          : DataActiveStatusEnum.ACTIVE;
    },

    doGetById: (state, action: PayloadAction<string>) => {
      state.loading = true;
    },
    doGetList: (state) => {
      if (!state.toggleLoading) {
        state.loading = true;
      }
    },
    setList: (state, action: PayloadAction<Array<IData>>) => {
      state.list = action.payload;
    },
    setDataForm: (state, action: PayloadAction<IData>) => {
      state.formData = action.payload;
    },
    doGetAllRetailerProductList: (state) => {},
    setAllList: (state, action: PayloadAction<Array<IData>>) => {
      state.allList = action.payload;
    },
       //excel list
    doGetExcelList: (state) => {
      state.loading = true;
    },
    doGetExcelListById: (state, action: PayloadAction<string>) => {
      state.loading = true;
    },
    setExcelList: (state, action: PayloadAction<IExcelListData[]>) => {
      state.excelList = action.payload;
    },
    setExcelDetailsList: (state, action: PayloadAction<IExcelDetailsData[]>) => {
      state.excelDetailsList = action.payload;
    },
      uploadImage: (
      state,
      action: PayloadAction<{
        fileName: string;
        name: string;
        callback: () => void;
      }>
    ) => {},
  },
});

export const { reducer, actions, name: sliceKey } = useClinicSlice;
